export const environment = {
  production: false,
  graphql: {
    uri: 'https://api.staging.iqd-pro.com/graphql',
  },
  sentry: {
    dsn: 'https://8ee1b4a1c0207648be1690a6757d4c3c@o4509351712194560.ingest.de.sentry.io/4512022268149840',
    enabled: true,
  },
  // Production is the only environment that reports to GTM. Development and
  // staging traffic would otherwise land in the live container and count as
  // real sessions in GA4.
  gtm: {
    id: 'GTM-WH899QZ6',
    enabled: false,
  },
};
